import anticipatedCompletionDate from "../../assets/projectTimeline/anticipatedCompletionDate.png";
import commissionedDate from "../../assets/projectTimeline/commissionedDate.png";
import implementationStartDate from "../../assets/projectTimeline/implementationStartDate.png";
import onHoldDate from "../../assets/projectTimeline/onHoldDate.png";
import partiallyCommissionedDate from "../../assets/projectTimeline/partiallyCommissionedDate.png";
import rejectedDate from "../../assets/projectTimeline/rejectedDate.png";
import resolutionDate from "../../assets/projectTimeline/resolutionDate.png";
import revisedTargetCompletionDate from "../../assets/projectTimeline/revisedTargetCompletionDate.png";
import underConstructionDate from "../../assets/projectTimeline/underConstructionDate.png";
import verificationDate from "../../assets/projectTimeline/verificationDate.png";
import pragatiDates from "../../assets/projectTimeline/pragatiDates.png";
import pmFoundationStoneDate from "../../assets/projectTimeline/pmFoundationStoneDate.png";

export const timelineColor = [
  "#E8464F",
  "#F38935",
  "#F2AE2D",
  "#81B94C",
  "#28B9AF",
  "#0E7A86",
  "#009ADB",
  "#167EC7",
  "#E03287",
  "#8331E2",
  "#3C1FDB"
];

export const colorClass = {
  "#E8464F": "timeline-color-red",
  "#F38935": "timeline-color-orange",
  "#F2AE2D": "timeline-color-yellow",
  "#81B94C": "timeline-color-green",
  "#28B9AF": "timeline-color-leaf-green",
  "#0E7A86": "timeline-color-dark-green",
  "#009ADB": "timeline-color-light-blue",
  "#167EC7": "timeline-color-blue",
  "#E03287": "timeline-color-pink",
  "#8331E2": "timeline-color-purple",
  "#3C1FDB": "timeline-color-dark-blue"
};

export const anticipatedTextColors = {
  "#DB8700": "text-yellow",
  "#000000": "text-black",
  "#FF2E2E": "text-red"
};

export const datesObj = {
  anticipatedCompletionDate: "Anticipated Completion",
  commissionedDate: "Project Commissioned",
  implementationStartDate: "Started Implementation",
  onHoldDate: "On Hold",
  partiallyCommissionedDate: "Partially Commissioned",
  rejectedDate: "Project Rejected",
  resolutionDate: "Project Resolved",
  revisedTargetCompletionDate: "Revised Target Completion",
  underConstructionDate: "Project Progress",
  verificationDate: "Under PMG Mechanism",
  pragatiReviewDate1: "1st Pragati Review",
  pragatiReviewDate2: "2nd Pragati Review",
  pragatiReviewDate3: "3rd Pragati Review",
  pragatiReviewDate4: "4th Pragati Review",
  pragatiReviewDate5: "5th Pragati Review",
  pragatiReviewDate6: "6th Pragati Review",
  pragatiReviewDate7: "7th Pragati Review",
  pragatiReviewDate8: "8th Pragati Review",
  pragatiReviewDate9: "9th Pragati Review",
  pragatiReviewDate10: "10th Pragati Review",
  pmFoundationStoneDate: "PM Foundation Stone"
};

export const datesObjState = {
  anticipatedCompletionDate: "Anticipated Completion",
  commissionedDate: "Project Commissioned",
  implementationStartDate: "Started Implementation",
  onHoldDate: "On Hold",
  partiallyCommissionedDate: "Partially Commissioned",
  rejectedDate: "Project Rejected",
  resolutionDate: "Project Resolved",
  revisedTargetCompletionDate: "Revised Target Completion",
  underConstructionDate: "Project Progress",
  verificationDate: "Under State PMG Mechanism",
  pragatiReviewDate1: "1st Pragati Review",
  pragatiReviewDate2: "2nd Pragati Review",
  pragatiReviewDate3: "3rd Pragati Review",
  pragatiReviewDate4: "4th Pragati Review",
  pragatiReviewDate5: "5th Pragati Review",
  pragatiReviewDate6: "6th Pragati Review",
  pragatiReviewDate7: "7th Pragati Review",
  pragatiReviewDate8: "8th Pragati Review",
  pragatiReviewDate9: "9th Pragati Review",
  pragatiReviewDate10: "10th Pragati Review",
  pmFoundationStoneDate: "PM Foundation Stone"
};

export const getImagePath = projectStage => {
  if (projectStage.startsWith("pragatiReviewDate")) {
    return pragatiDates;
  }
  switch (projectStage) {
    case "anticipatedCompletionDate":
      return anticipatedCompletionDate;
    case "commissionedDate":
      return commissionedDate;
    case "implementationStartDate":
      return implementationStartDate;
    case "onHoldDate":
      return onHoldDate;
    case "partiallyCommissionedDate":
      return partiallyCommissionedDate;
    case "rejectedDate":
      return rejectedDate;
    case "resolutionDate":
      return resolutionDate;
    case "revisedTargetCompletionDate":
      return revisedTargetCompletionDate;
    case "underConstructionDate":
      return underConstructionDate;
    case "verificationDate":
      return verificationDate;
    case "pmFoundationStoneDate":
      return pmFoundationStoneDate;
    default:
      return "";
  }
};
